// import request from '@/utils/request'
import axios from 'axios'
import global from '@/global/variable.js'

// 按 name 或 type 搜索匹配的字典
export function getDicyType({ name, type }) {
  const payload = {
    where: {
      "eq_dt.name": name || undefined,
      "eq_dt.type": type || undefined,
    },
  };
  const url = global.requestUrl + "/sys/dict/list";
  return axios.post(url, payload);
}

// 按 name 或 type 搜索匹配的字典
export function getDictOne({ name, type }) {
  const payload = {
    where: {
      "eq_dt.name": name || undefined,
      "eq_dt.type": type || undefined,
    },
  };
  const url = global.requestUrl + "/sys/dict/list";
  return axios.post(url, payload).then(res => {
    if (res.status === 200 && res.data.code === 2000) {
      if (res.data.data && Array.isArray(res.data.data) && res.data.data.length) {
        return res.data.data[0].dictDataList || []
      }
    }
    return []
  });
}